import styled from 'astroturf/react';

const VeloModalSheetFooter = styled('div')`
  padding: 1rem 1rem 0 1rem;
`;

export { VeloModalSheetFooter };
